module.exports = __webpack_public_path__ + "static/IvarText-Regular-829c87eb9ea87d8e79bc59554d97c8cd.woff";